// #region Imports
// React and related hooks
import { useEffect, useState } from 'react';

// Material-UI components
import {
  Button,
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  ThemeProvider,
  Typography,
} from '@mui/material';

// FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';

// Custom utilities and hooks
import { GlobalVariables } from '../../../globalVar';
import customAxios from '../../../utils/customAxios';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';

// Styles
import variables from '../../../scss/_variables.scss';
import { getToast } from '../../../utils/toastConfig';
// #endregion

const theme = createTheme({
  palette: {
    primary: {
      main: variables.redDabi,
    },
  },
});

export const CreateRoleModal = ({ showModal, setShowModal, refreshData }) => {
  const { nameString, codeString, descriptionString, saveString } =
    useTranslationHook();

  //* Data
  const [rolName, setRolName] = useState('');
  const [description, setDescription] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  const resetFormFields = () => {
    setRolName('');
    setDescription('');
  };

  //* Data submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const requestData = {
      role_name: rolName,
      description: description,
    };

    try {
      const endpoint = `${GlobalVariables.getURL()}roles/create`;

      const response = await customAxios.post(endpoint, requestData, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });

      if (response.status === 200) {
        getToast({
          status: 'success',
          title: 'Rol creado correctamente',
        });
        resetFormFields();
        setShowModal(false);
        refreshData();
      }
    } catch (error) {
      getToast({ status: 'error', title: error.response.data.message });
    } finally {
      setIsLoading(false);
    }
    resetFormFields();
    setShowModal(false);
    refreshData();
  };

  //#endregion

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={showModal}
        onClose={() => {
          setShowModal(false);
          resetFormFields();
        }}
        fullWidth={true}
        maxWidth='md'
      >
        <DialogTitle>
          <Typography className='inventory-movmodal-title'>
            Nuevo rol
          </Typography>
        </DialogTitle>
        <IconButton
          aria-label='close'
          onClick={() => {
            setShowModal(false);
            resetFormFields();
          }}
          sx={{
            position: 'absolute',
            right: 20,
            top: 20,
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
        <DialogContent dividers>
          <form id='create-bank-form' onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {/* //* Row 1 */}
              <Grid item xs={12} container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    sx={{ width: '100%' }}
                    label='Nombre del rol'
                    type='text'
                    value={rolName}
                    onChange={(e) => setRolName(e.target.value)}
                    required
                  />
                </Grid>
              </Grid>
              {/* //* Row 2 */}
              <Grid item xs={12}>
                <TextField
                  sx={{ width: '100%' }}
                  label='Descripción'
                  type='text'
                  multiline
                  rows={3}
                  value={description ?? ' '}
                  onChange={(e) => {
                    setDescription(e.target.value);
                  }}
                />
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            variant='contained'
            type='submit'
            form='create-bank-form'
            disabled={isLoading}
          >
            <Typography color='#FFFFFF'>{saveString.toUpperCase()}</Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};
